import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationMarkBlack30 = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M14.9761 12.9762C13.876 12.9762 12.9761 13.8885 12.9761 15.0037V21.2344C12.9761 22.3496 13.876 23.2619 14.9761 23.2619C16.0761 23.2619 16.9761 22.3496 16.9761 21.2344V15.0037C16.9761 13.8885 16.0761 12.9762 14.9761 12.9762Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M14.9761 6.94444C13.8761 6.94444 12.9761 7.84441 12.9761 8.9445C12.9761 10.0445 13.8761 10.9444 14.9761 10.9444C16.076 10.9444 16.9761 10.0445 16.9761 8.9445C16.9761 7.84441 16.076 6.94444 14.9761 6.94444Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M15.0002 26.3684C8.73162 26.3684 3.63177 21.2685 3.63177 14.9999C3.63177 8.73135 8.73162 3.6316 15.0002 3.6316C21.2687 3.6316 26.3686 8.73135 26.3686 14.9999C26.3686 21.2685 21.2687 26.3684 15.0002 26.3684ZM15.0001 0C6.72898 0 0 6.72889 0 14.9999C0 23.271 6.72898 30 15.0001 30C23.271 30 30 23.271 30 14.9999C30 6.72889 23.271 0 15.0001 0Z",
	fill: "white"
}));
const ForwardRef = forwardRef(SvgExclamationMarkBlack30);
export default ForwardRef;
